/* Pluszkowo theme.js, bez zależności */
(function () {
  'use strict';

  window.PluszkowoBooted = false;
  var P = window.Pluszkowo = window.Pluszkowo || {};
  P.routes = P.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  P.tiers = P.tiers || [];
  var doc = document;
  var html = doc.documentElement;
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };
  var reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');
  var motionOK = function () { return !reduceMq.matches; };
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var PALETTE = ['#FF8FB1', '#FFD23F', '#7CC77A', '#6FB8FF', '#A58BFF', '#FF9B3D'];
  var ICON_SWAP = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9h13l-3-3M20 15H7l3 3"/></svg>';

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function plural(n, one, few, many) {
    if (n === 1) return one;
    var m10 = n % 10, m100 = n % 100;
    if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return few;
    return many;
  }

  function formatMoney(cents, format) {
    cents = Math.round(Number(cents) || 0);
    format = String(format || P.moneyFormat || '{{amount_with_comma_separator}} zł').replace(/<[^>]*>/g, '');
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(n, prec, thou, dec) {
      thou = thou == null ? ',' : thou;
      dec = dec == null ? '.' : dec;
      var parts = (n / 100).toFixed(prec).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thou);
      return whole + (parts[1] ? dec + parts[1] : '');
    }
    var m = format.match(re);
    if (!m) return (cents / 100).toFixed(2);
    var v;
    switch (m[1]) {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': v = fmt(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(re, v);
  }

  function tierFor(count) {
    var pct = 0, name = '';
    P.tiers.forEach(function (t) { if (count >= t.qty && t.pct > pct) { pct = t.pct; name = t.name; } });
    return { pct: pct, name: name };
  }

  function restart(el, cls) {
    if (!el) return;
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
  }

  function parseJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('[data-toast]');
    if (!t) return;
    t.textContent = msg;
    t.hidden = false;
    requestAnimationFrame(function () { t.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      t.classList.remove('is-on');
      setTimeout(function () { t.hidden = true; }, 500);
    }, 2800);
  }

  /* ---------- Konfetti z łapek, gwiazdek i serduszek ---------- */
  var SHAPES = [
    '<svg viewBox="0 0 24 24"><path fill="C" stroke="#2B2340" stroke-width="1.6" d="M12 2.8 14.6 8l5.6.8-4 4 .9 5.6L12 15.8l-5.1 2.6.9-5.6-4-4L9.4 8Z"/></svg>',
    '<svg viewBox="0 0 24 24"><path fill="C" stroke="#2B2340" stroke-width="1.6" d="M12 20.5C6 15.8 3 13 3 9.3a4.6 4.6 0 0 1 9-1.6 4.6 4.6 0 0 1 9 1.6c0 3.7-3 6.5-9 11.2Z"/></svg>',
    '<svg viewBox="0 0 24 24"><g fill="C" stroke="#2B2340" stroke-width="1.2"><ellipse cx="6" cy="10" rx="2.1" ry="2.6"/><ellipse cx="10" cy="6.2" rx="2.1" ry="2.7"/><ellipse cx="14.6" cy="6.2" rx="2.1" ry="2.7"/><ellipse cx="18.4" cy="10" rx="2.1" ry="2.6"/><path d="M12.3 11.4c-3 0-6 3.4-6 6.1 0 1.8 1.4 2.8 3 2.8 1.2 0 2-.6 3-.6s1.8.6 3 .6c1.6 0 3-1 3-2.8 0-2.7-3-6.1-6-6.1Z"/></g></svg>',
    '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="7" fill="C" stroke="#2B2340" stroke-width="1.8"/></svg>'
  ];
  function confetti(x, y, count) {
    var layer = $('[data-confetti]');
    if (!layer || !motionOK() || !layer.animate) return;
    count = count || 26;
    for (var i = 0; i < count; i++) {
      var bit = doc.createElement('span');
      bit.className = 'confetti__bit';
      bit.innerHTML = SHAPES[i % SHAPES.length].replace(/C/, PALETTE[(Math.random() * PALETTE.length) | 0]);
      var size = 12 + Math.random() * 14;
      bit.style.width = size + 'px';
      bit.style.height = size + 'px';
      layer.appendChild(bit);
      var angle = Math.random() * Math.PI * 2;
      var power = 80 + Math.random() * 170;
      var dx = Math.cos(angle) * power;
      var dy = Math.sin(angle) * power - 120;
      var rot = (Math.random() - 0.5) * 720;
      var anim = bit.animate([
        { transform: 'translate(' + x + 'px,' + y + 'px) scale(.3) rotate(0deg)', opacity: 1 },
        { transform: 'translate(' + (x + dx) + 'px,' + (y + dy) + 'px) scale(1) rotate(' + rot / 2 + 'deg)', opacity: 1, offset: 0.45 },
        { transform: 'translate(' + (x + dx * 1.25) + 'px,' + (y + dy + 260) + 'px) scale(.8) rotate(' + rot + 'deg)', opacity: 0 }
      ], { duration: 1100 + Math.random() * 700, easing: 'cubic-bezier(.2,.7,.4,1)' });
      anim.onfinish = (function (b) { return function () { b.remove(); }; })(bit);
    }
  }
  function confettiFrom(el, count) {
    if (!el) return;
    var r = el.getBoundingClientRect();
    confetti(r.left + r.width / 2, r.top + r.height / 2, count);
  }

  /* ---------- Szuflady (koszyk i menu) ---------- */
  var Drawer = {
    current: null,
    lastFocus: null,
    open: function (name) {
      var d = $('[data-drawer="' + name + '"]');
      if (!d) return;
      if (this.current && this.current !== d) this.close(true);
      this.lastFocus = doc.activeElement;
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      html.classList.add('lock');
      this.current = d;
      if (name === 'menu') $$('[data-open-menu]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var panel = $('.drawer__panel', d);
      panel.setAttribute('tabindex', '-1');
      setTimeout(function () {
        var f = $('[data-close-drawer].icon-btn', d) || panel;
        f.focus({ preventScroll: true });
      }, 60);
    },
    close: function (silent) {
      var d = this.current;
      if (!d) return;
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      html.classList.remove('lock');
      this.current = null;
      $$('[data-open-menu]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (!silent && this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
    }
  };

  function initDrawers() {
    doc.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-close-drawer]')) { e.preventDefault(); Drawer.close(); return; }
      if (t.closest('[data-close-on-click]')) { Drawer.close(true); return; }
      var cartBtn = t.closest('[data-open-cart]');
      if (cartBtn && !$('[data-cart-page]')) { e.preventDefault(); Drawer.open('cart'); return; }
      if (t.closest('[data-open-menu]')) { e.preventDefault(); Drawer.open('menu'); }
    });
    doc.addEventListener('keydown', function (e) {
      if (!Drawer.current) return;
      if (e.key === 'Escape') { Drawer.close(); return; }
      if (e.key !== 'Tab') return;
      var items = $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', $('.drawer__panel', Drawer.current))
        .filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------- Koszyk (AJAX + Section Rendering API) ---------- */
  var Cart = {
    count: null,
    url: function (base) { return base + '.js'; },
    request: function (url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'Coś poszło nie tak. Spróbuj jeszcze raz.');
          return data;
        });
      });
    },
    add: function (items) {
      return this.request(this.url(P.routes.cartAdd), { items: items, sections: 'cart-drawer', sections_url: window.location.pathname })
        .then(function (data) { Cart.render(data.sections); return data; });
    },
    change: function (key, quantity) {
      return this.request(this.url(P.routes.cartChange), { id: key, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
        .then(function (data) { Cart.render(data.sections); return data; });
    },
    refresh: function () {
      var root = P.routes.root || '/';
      if (root.slice(-1) !== '/') root += '/';
      return fetch(root + '?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (t) {
        Cart.render({ 'cart-drawer': t });
      });
    },
    render: function (sections) {
      var htmlStr = sections && sections['cart-drawer'];
      if (!htmlStr) { this.refresh(); return; }
      var dom = new DOMParser().parseFromString(htmlStr, 'text/html');
      var fresh = $('[data-cart-content]', dom);
      var current = $('[data-cart-content]');
      if (!fresh || !current) return;
      var oldFill = $('.tiers__fill', current);
      var oldWidth = oldFill ? oldFill.style.width : '0%';
      var hadFocus = current.contains(doc.activeElement);
      current.replaceWith(fresh);
      var newFill = $('.tiers__fill', fresh);
      if (newFill && motionOK()) {
        var target = newFill.style.width;
        newFill.style.transition = 'none';
        newFill.style.width = oldWidth;
        void newFill.offsetWidth;
        newFill.style.transition = '';
        requestAnimationFrame(function () { newFill.style.width = target; });
      }
      if (hadFocus) { var close = $('[data-close-drawer].icon-btn', fresh); if (close) close.focus({ preventScroll: true }); }
      var count = parseInt(fresh.getAttribute('data-cart-count'), 10) || 0;
      this.updateCount(count);
    },
    updateCount: function (count) {
      var prev = this.count;
      this.count = count;
      $$('[data-cart-bubble]').forEach(function (b) {
        b.textContent = count;
        b.classList.toggle('is-empty', count === 0);
      });
      $$('.header__cart').forEach(function (a) { a.setAttribute('aria-label', 'Koszyk, liczba produktów: ' + count); });
      if (prev !== null && count > prev) {
        $$('.header__cart').forEach(function (a) { restart(a, 'is-bump'); });
        var before = tierFor(prev).pct, after = tierFor(count);
        if (after.pct > before) {
          toast('Odblokowane: -' + after.pct + '% za pakiet ' + after.name + '!');
          confetti(window.innerWidth - 60, 70, 34);
        }
      }
    }
  };

  function initCart() {
    var content = $('[data-cart-content]');
    if (content) Cart.count = parseInt(content.getAttribute('data-cart-count'), 10) || 0;

    doc.addEventListener('click', function (e) {
      var change = e.target.closest('[data-line-change]');
      if (change) {
        e.preventDefault();
        var line = change.closest('.cart-line');
        if (line) line.classList.add('is-busy');
        Cart.change(change.getAttribute('data-key'), parseInt(change.getAttribute('data-qty'), 10))
          .then(function () { if ($('[data-cart-page]')) window.location.reload(); })
          .catch(function (err) { if (line) line.classList.remove('is-busy'); toast(err.message); });
        return;
      }
      var quick = e.target.closest('[data-quick-add]');
      if (quick) {
        e.preventDefault();
        quick.classList.add('is-loading');
        Cart.add([{ id: parseInt(quick.getAttribute('data-quick-add'), 10), quantity: 1 }])
          .then(function () { confettiFrom($('.header__cart'), 18); })
          .catch(function (err) { quick.classList.remove('is-loading'); toast(err.message); });
      }
    });
  }

  /* ---------- Nagłówek ---------- */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Tryb nocny z okrągłym przejściem ---------- */
  function initNight() {
    var sky = $('.night-sky');
    if (sky && !sky.children.length) {
      var frag = doc.createDocumentFragment();
      for (var i = 0; i < (finePointer ? 14 : 6); i++) {
        var s = doc.createElement('i');
        s.style.left = (Math.random() * 100).toFixed(2) + '%';
        s.style.top = (Math.random() * 100).toFixed(2) + '%';
        s.style.setProperty('--s', (2 + Math.random() * 3).toFixed(1) + 'px');
        s.style.setProperty('--t', (2 + Math.random() * 3).toFixed(1) + 's');
        s.style.setProperty('--dl', (-Math.random() * 4).toFixed(1) + 's');
        frag.appendChild(s);
      }
      sky.appendChild(frag);
    }
    $$('[data-night-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', html.hasAttribute('data-night') ? 'true' : 'false');
      btn.addEventListener('click', function () {
        var on = !html.hasAttribute('data-night');
        var apply = function () {
          if (on) html.setAttribute('data-night', '1'); else html.removeAttribute('data-night');
          try { localStorage.setItem('pluszkowo-night', on ? '1' : '0'); } catch (e) {}
          $$('[data-night-toggle]').forEach(function (b) { b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        };
        if (doc.startViewTransition && motionOK()) {
          var r = btn.getBoundingClientRect();
          var x = r.left + r.width / 2, y = r.top + r.height / 2;
          var rad = Math.hypot(Math.max(x, window.innerWidth - x), Math.max(y, window.innerHeight - y));
          var t = doc.startViewTransition(apply);
          t.ready.then(function () {
            html.animate({ clipPath: ['circle(0px at ' + x + 'px ' + y + 'px)', 'circle(' + rad + 'px at ' + x + 'px ' + y + 'px)'] },
              { duration: 700, easing: 'cubic-bezier(.6,0,.2,1)', pseudoElement: '::view-transition-new(root)' });
          }).catch(function () {});
        } else {
          apply();
        }
      });
    });
  }

  /* ---------- Pojawianie się elementów ---------- */
  var revealObserver = null;
  function initReveal(root) {
    var els = $$('[data-reveal]:not(.is-in)', root);
    if (!('IntersectionObserver' in window) || !motionOK() || P.designMode) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); revealObserver.unobserve(en.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { revealObserver.observe(el); });
  }

  /* ---------- Rozbijanie tytułu na litery ---------- */
  function splitText(el) {
    if (el.classList.contains('is-split')) return;
    var i = 0;
    var walk = function (node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = doc.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(doc.createTextNode(' ')); return; }
            var w = doc.createElement('span');
            w.className = 'w';
            w.setAttribute('aria-hidden', 'true');
            Array.from(part).forEach(function (ch) {
              var s = doc.createElement('span');
              s.className = 'ch';
              s.textContent = ch;
              s.style.setProperty('--i', i++);
              w.appendChild(s);
            });
            frag.appendChild(w);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1) {
          walk(n);
        }
      });
    };
    walk(el);
    el.classList.add('is-split');
  }

  /* ---------- Oczka za kursorem ---------- */
  function initGoogly() {
    if (!finePointer || !motionOK()) return;
    var eyes = $$('.googly__eye');
    if (!eyes.length) return;
    var px = window.innerWidth / 2, py = window.innerHeight / 3, ticking = false;
    var update = function () {
      ticking = false;
      eyes.forEach(function (eye) {
        var r = eye.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
        var a = Math.atan2(py - cy, px - cx);
        var d = Math.min(Math.hypot(px - cx, py - cy) / 12, r.width * 0.24);
        var pupil = eye.firstElementChild;
        pupil.style.setProperty('--ex', (Math.cos(a) * d).toFixed(1) + 'px');
        pupil.style.setProperty('--ey', (Math.sin(a) * d).toFixed(1) + 'px');
      });
    };
    window.addEventListener('pointermove', function (e) {
      px = e.clientX; py = e.clientY;
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
    if (!motionOK()) return;
    setInterval(function () {
      $$('[data-googly]').forEach(function (g) {
        if (Math.random() < 0.35) {
          g.classList.add('is-blink');
          setTimeout(function () { g.classList.remove('is-blink'); }, 220);
        }
      });
    }, 1800);
  }

  /* ---------- Przechył 3D za kursorem ---------- */
  function initTilt(root) {
    if (!finePointer || !motionOK()) return;
    $$('[data-tilt]', root).forEach(function (el) {
      if (el._tilt) return;
      el._tilt = true;
      el.addEventListener('pointermove', function (e) {
        if (!motionOK()) return;
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        el.style.setProperty('--ry', ((x - 0.5) * 12).toFixed(2) + 'deg');
        el.style.setProperty('--rx', ((0.5 - y) * 10).toFixed(2) + 'deg');
        el.style.setProperty('--lx', (x * 100).toFixed(1) + '%');
      });
      el.addEventListener('pointerleave', function () {
        el.style.setProperty('--ry', '0deg');
        el.style.setProperty('--rx', '0deg');
      });
    });
  }

  /* ---------- Przycisk-magnes ---------- */
  function initMagnet(root) {
    if (!finePointer || !motionOK()) return;
    $$('[data-magnet]', root).forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        if (!motionOK()) return;
        var r = el.getBoundingClientRect();
        var x = e.clientX - r.left - r.width / 2, y = e.clientY - r.top - r.height / 2;
        el.style.transform = 'translate(' + (x * 0.22).toFixed(1) + 'px,' + (y * 0.3).toFixed(1) + 'px)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------- Galaretka po kliknięciu przycisku ---------- */
  function initJelly() {
    doc.addEventListener('click', function (e) {
      var b = e.target.closest('.btn');
      if (!b || !motionOK()) return;
      restart(b, 'is-jelly');
      setTimeout(function () { b.classList.remove('is-jelly'); }, 600);
    });
  }

  /* ---------- Paski przewijane, przyspieszają przy scrollu ---------- */
  var scrollBoost = 0, scrollDir = 1, lastY = window.scrollY;
  window.addEventListener('scroll', function () {
    var y = window.scrollY, dy = y - lastY;
    lastY = y;
    if (dy !== 0) scrollDir = dy > 0 ? 1 : -1;
    scrollBoost = Math.min(scrollBoost + Math.abs(dy) * 0.06, 6);
  }, { passive: true });

  var marquees = [];
  var marqueeRunning = false;
  function initMarquee(root) {
    $$('[data-marquee]', root).forEach(function (track) {
      if (!finePointer) { track.parentElement.classList.add('is-static'); return; }
      if (track._mq) return;
      var m = {
        el: track,
        x: 0,
        w: 0,
        speed: parseFloat(track.getAttribute('data-speed') || '0.5') * 60,
        dir: track.getAttribute('data-direction') === '1' ? 1 : -1,
        paused: false,
        visible: true
      };
      track._mq = m;
      // Bez animacji (ograniczony ruch) opinie mają się dać przewinąć palcem, a nie stać w miejscu.
      if (!motionOK() && track.parentElement && track.parentElement.classList.contains('reviews__row')) track.parentElement.classList.add('is-static');
      var measure = function () { var g = track.firstElementChild; m.w = g ? g.getBoundingClientRect().width : 0; };
      measure();
      if ('ResizeObserver' in window) new ResizeObserver(measure).observe(track.firstElementChild);
      if (track.hasAttribute('data-pause-hover')) {
        track.addEventListener('pointerenter', function () { m.paused = true; });
        track.addEventListener('pointerleave', function () { m.paused = false; });
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { m.visible = en[0].isIntersecting; }).observe(track);
      }
      marquees.push(m);
    });
    if (!marqueeRunning && marquees.length && motionOK()) {
      marqueeRunning = true;
      var last = performance.now();
      var loop = function (now) {
        var dt = Math.min((now - last) / 1000, 0.05);
        last = now;
        scrollBoost *= 0.92;
        marquees.forEach(function (m) {
          if (!m.visible || !m.w || !m.el.isConnected) return;
          var v = m.paused ? 0 : m.speed * (1 + scrollBoost);
          m.x += m.dir * scrollDir * v * dt;
          if (m.x <= -m.w) m.x += m.w;
          if (m.x > 0) m.x -= m.w;
          m.el.style.transform = 'translate3d(' + m.x.toFixed(2) + 'px,0,0)';
        });
        requestAnimationFrame(loop);
      };
      requestAnimationFrame(loop);
    }
  }

  /* ---------- Paralaksa ---------- */
  function initParallax() {
    if (!motionOK() || !finePointer) return;
    var els = $$('[data-parallax]');
    if (!els.length) return;
    var ticking = false;
    var update = function () {
      ticking = false;
      if (!motionOK()) return;
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var k = parseFloat(el.getAttribute('data-parallax')) || 0;
        var off = ((r.top + r.height / 2) - vh / 2) / vh;
        el.style.setProperty('--py', (off * k * -1.6).toFixed(1) + 'px');
      });
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
    var hero = $('.hero');
    if (hero && finePointer) {
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        hero.style.setProperty('--mx', (((e.clientX - r.left) / r.width - 0.5) * 2).toFixed(2));
        hero.style.setProperty('--my', (((e.clientY - r.top) / r.height - 0.5) * 2).toFixed(2));
      });
      hero.addEventListener('pointerleave', function () { hero.style.setProperty('--mx', 0); hero.style.setProperty('--my', 0); });
    }
  }

  /* ---------- Ślady łapek za kursorem ---------- */
  function initPaws() {
    if (!finePointer || !motionOK()) return;
    var layer = doc.createElement('div');
    layer.className = 'paws';
    layer.setAttribute('aria-hidden', 'true');
    doc.body.appendChild(layer);
    var pool = [];
    var svg = '<svg viewBox="0 0 24 24" fill="currentColor"><ellipse cx="6" cy="10" rx="2.1" ry="2.6"/><ellipse cx="10" cy="6.2" rx="2.1" ry="2.7"/><ellipse cx="14.6" cy="6.2" rx="2.1" ry="2.7"/><ellipse cx="18.4" cy="10" rx="2.1" ry="2.6"/><path d="M12.3 11.4c-3 0-6 3.4-6 6.1 0 1.8 1.4 2.8 3 2.8 1.2 0 2-.6 3-.6s1.8.6 3 .6c1.6 0 3-1 3-2.8 0-2.7-3-6.1-6-6.1Z"/></svg>';
    for (var i = 0; i < 14; i++) {
      var p = doc.createElement('span');
      p.className = 'paw';
      p.innerHTML = svg;
      layer.appendChild(p);
      pool.push(p);
    }
    var idx = 0, lx = null, ly = null, dist = 0, side = 1;
    var zones = '.hero, .squad, .quiz, .crew, .join, .notfound';
    window.addEventListener('pointermove', function (e) {
      if (!e.target.closest || !e.target.closest(zones) || e.target.closest('input, textarea, select, button, a')) { lx = null; return; }
      if (lx === null) { lx = e.clientX; ly = e.clientY; return; }
      var dx = e.clientX - lx, dy = e.clientY - ly;
      dist += Math.hypot(dx, dy);
      if (dist < 95) return;
      dist = 0;
      var ang = Math.atan2(dy, dx);
      side *= -1;
      var ox = Math.cos(ang + Math.PI / 2) * 9 * side, oy = Math.sin(ang + Math.PI / 2) * 9 * side;
      var paw = pool[idx++ % pool.length];
      paw.classList.remove('is-on');
      paw.style.setProperty('--t', 'translate(' + (e.clientX + ox - 10).toFixed(0) + 'px,' + (e.clientY + oy - 10).toFixed(0) + 'px) rotate(' + (ang * 180 / Math.PI + 90).toFixed(0) + 'deg)');
      paw.style.color = PALETTE[idx % PALETTE.length];
      void paw.offsetWidth;
      paw.classList.add('is-on');
      lx = e.clientX; ly = e.clientY;
    }, { passive: true });
  }

  /* ---------- Karty postaci (obracanie) ---------- */
  function initFlip(root) {
    $$('[data-flip]', root).forEach(function (inner) {
      if (inner._flip) return;
      inner._flip = true;
      var front = $('.fcard__front', inner), back = $('.fcard__back', inner);
      $$('[data-flip-btn]', inner).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var flipped = !inner.classList.contains('is-flipped');
          inner.classList.toggle('is-flipped', flipped);
          if (flipped) { front.setAttribute('inert', ''); back.removeAttribute('inert'); }
          else { back.setAttribute('inert', ''); front.removeAttribute('inert'); }
          var target = $('[data-flip-btn]', flipped ? back : front);
          if (target) setTimeout(function () { target.focus({ preventScroll: true }); }, 50);
        });
      });
    });
  }

  /* ---------- Liczniki ---------- */
  function initCounters(root) {
    var els = $$('[data-count]', root);
    if (!els.length) return;
    var run = function (el) {
      var to = parseInt(el.getAttribute('data-count'), 10) || 0;
      var suffix = el.getAttribute('data-suffix') || '';
      if (!motionOK()) { el.textContent = to + suffix; return; }
      var start = performance.now(), dur = 1400;
      var step = function (now) {
        var p = Math.min((now - start) / dur, 1);
        var e = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(to * e) + suffix;
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.6 });
    els.forEach(function (el) { el.textContent = '0' + (el.getAttribute('data-suffix') || ''); io.observe(el); });
  }

  /* ---------- Odliczanie do Halloween ---------- */
  function initCountdown(root) {
    $$('[data-countdown]', root).forEach(function (box) {
      if (box._cd) return;
      box._cd = true;
      var now = new Date();
      var target = new Date(now.getFullYear(), 9, 31, 0, 0, 0);
      var endOfDay = new Date(now.getFullYear(), 9, 31, 23, 59, 59);
      if (now > endOfDay) target = new Date(now.getFullYear() + 1, 9, 31, 0, 0, 0);
      var cells = { d: $('[data-cd="d"]', box), h: $('[data-cd="h"]', box), m: $('[data-cd="m"]', box), s: $('[data-cd="s"]', box) };
      var set = function (k, v) {
        var el = cells[k];
        if (!el) return;
        var str = String(v).padStart(2, '0');
        if (el.textContent !== str) { el.textContent = str; if (motionOK()) restart(el.parentNode, 'is-tick'); }
      };
      var tick = function () {
        var diff = Math.max(0, target - new Date());
        set('d', Math.floor(diff / 864e5));
        set('h', Math.floor(diff / 36e5) % 24);
        set('m', Math.floor(diff / 6e4) % 60);
        set('s', Math.floor(diff / 1e3) % 60);
        if (diff === 0) box.setAttribute('aria-label', 'Halloween jest dzisiaj');
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Modal z tabelą rozmiarów ---------- */
  function initModals() {
    doc.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-open-modal]');
      if (opener) {
        e.preventDefault();
        var m = doc.getElementById(opener.getAttribute('data-open-modal'));
        if (!m) return;
        m._opener = opener;
        if (m.showModal) m.showModal(); else m.setAttribute('open', '');
        return;
      }
      var closer = e.target.closest('[data-close-modal]');
      var dlg = e.target.closest('dialog.modal');
      if (closer && dlg) { closeModal(dlg); return; }
      if (e.target.matches && e.target.matches('dialog.modal')) closeModal(e.target);
    });
    function closeModal(m) {
      if (m.close) m.close(); else m.removeAttribute('open');
      if (m._opener) m._opener.focus({ preventScroll: true });
    }
  }

  /* ---------- Quiz ---------- */
  function initQuiz(root) {
    $$('[data-quiz]', root).forEach(function (wrap) {
      if (wrap._quiz) return;
      wrap._quiz = true;
      var data = parseJSON($('[data-quiz-data]', wrap));
      var stage = $('[data-quiz-stage]', wrap);
      var bar = $('[data-quiz-bar]', wrap);
      if (!data || !stage) return;
      var step = 0, scores = {}, lastPick = null;
      var letters = ['A', 'B', 'C', 'D', 'E'];

      var swap = function (fn) {
        if (!motionOK()) { fn(); return; }
        stage.classList.add('is-leaving');
        setTimeout(function () { stage.classList.remove('is-leaving'); fn(); }, 240);
      };
      var renderQ = function () {
        var q = data.questions[step];
        bar.style.width = (step / data.questions.length * 100) + '%';
        var out = '<p class="quiz__count">Pytanie ' + (step + 1) + ' z ' + data.questions.length + '</p>';
        out += '<p class="quiz__q" tabindex="-1">' + esc(q.q) + '</p><div class="quiz__answers">';
        q.a.forEach(function (a, i) {
          out += '<button type="button" class="quiz__a" data-letter="' + letters[i] + '" data-h="' + esc(a.h) + '" style="--i:' + i + '">' + esc(a.t) + '</button>';
        });
        stage.innerHTML = out + '</div>';
        var qEl = $('.quiz__q', stage);
        if (step > 0 && qEl) qEl.focus({ preventScroll: true });
      };
      var renderResult = function () {
        bar.style.width = '100%';
        var best = null, max = -1;
        Object.keys(scores).forEach(function (h) {
          if (scores[h] > max || (scores[h] === max && h === lastPick)) { max = scores[h]; best = h; }
        });
        var r = data.results[best];
        if (!r) return;
        var media = r.image
          ? '<img src="' + esc(r.image) + '" alt="' + esc(r.kind + ' ' + r.name) + '" loading="lazy">'
          : '<div class="quiz__res-face tone-' + esc(r.tone) + '" role="img" aria-label="' + esc(r.kind + ' ' + r.name) + '">' + (r.face || '') + '</div>';
        stage.innerHTML =
          '<div class="quiz__result">' +
            '<div class="quiz__res-media">' + media + '</div>' +
            '<div>' +
              '<p class="quiz__res-kicker">Wychodzi na to, że jesteś...</p>' +
              '<p class="quiz__res-name" tabindex="-1">' + esc(r.name) + '!</p>' +
              '<p class="quiz__res-text">' + esc(r.text) + '</p>' +
              '<div class="quiz__res-ctas">' +
                '<a class="btn btn--primary" href="' + esc(r.url) + '"><span class="btn__inner">Zobacz ' + esc(r.acc) + (r.price ? ', od ' + esc(r.price) : '') + '</span></a>' +
                '<button type="button" class="btn btn--ghost" data-quiz-share><span class="btn__inner">Pochwal się</span></button>' +
                '<button type="button" class="btn btn--ghost" data-quiz-again><span class="btn__inner">Jeszcze raz</span></button>' +
              '</div>' +
            '</div>' +
          '</div>';
        wrap._result = r;
        var n = $('.quiz__res-name', stage);
        if (n) n.focus({ preventScroll: true });
        confettiFrom($('.quiz__res-media', stage), 40);
      };

      wrap.addEventListener('click', function (e) {
        if (e.target.closest('[data-quiz-start]')) { step = 0; scores = {}; swap(renderQ); return; }
        if (e.target.closest('[data-quiz-again]')) { step = 0; scores = {}; lastPick = null; swap(renderQ); return; }
        if (e.target.closest('[data-quiz-share]')) {
          var r = wrap._result || {};
          var text = 'Zrobiłem quiz Pluszkowo i wyszło mi, że jestem jak ' + r.name + '. A Ty którym pluszkiem jesteś?';
          var url = window.location.origin + (P.routes.root || '/').replace(/\/$/, '') + '/#quiz';
          if (navigator.share) { navigator.share({ title: 'Którym pluszkiem jesteś?', text: text, url: url }).catch(function () {}); }
          else if (navigator.clipboard) { navigator.clipboard.writeText(text + ' ' + url).then(function () { toast('Skopiowane! Wklej kumplom na czacie.'); }); }
          return;
        }
        var ans = e.target.closest('.quiz__a');
        if (!ans || stage._busy) return;
        stage._busy = true;
        var h = ans.getAttribute('data-h');
        scores[h] = (scores[h] || 0) + 1;
        lastPick = h;
        ans.classList.add('is-picked');
        setTimeout(function () {
          stage._busy = false;
          step++;
          swap(step < data.questions.length ? renderQ : renderResult);
        }, motionOK() ? 380 : 0);
      });
    });
  }

  /* ---------- Kreator pakietów ---------- */
  function preferSize(list) {
    var prefs = ['150 cm', 'M'];
    for (var i = 0; i < prefs.length; i++) if (list.indexOf(prefs[i]) > -1) return prefs[i];
    return list[0];
  }

  function initBundles(root) {
    $$('[data-bundle]', root).forEach(function (wrap) {
      if (wrap._bundle) return;
      wrap._bundle = true;
      var data = parseJSON($('[data-bundle-data]', wrap));
      var products = (data && data.products || []).filter(function (p) { return p.variants && p.variants.length; });
      var byHandle = {};
      products.forEach(function (p) { byHandle[p.handle] = p; });
      var slotsEl = $('[data-slots]', wrap);
      var addBtn = $('[data-b-add]', wrap);
      var label = $('[data-b-label]', wrap);
      var cards = $$('.tiercard', wrap);
      var state = { qty: 2, pct: 0, slots: [] };

      var versionsOf = function (p) {
        var out = [];
        p.variants.forEach(function (v) { if (out.indexOf(v.o1) === -1) out.push(v.o1); });
        return out;
      };
      var sizesOf = function (p, version) {
        var out = [];
        p.variants.forEach(function (v) { if (v.o1 === version && v.o2 && out.indexOf(v.o2) === -1) out.push(v.o2); });
        return out;
      };
      var variantOf = function (slot) {
        var p = byHandle[slot.h];
        if (!p) return null;
        for (var i = 0; i < p.variants.length; i++) {
          var v = p.variants[i];
          if (v.o1 === slot.version && (v.o2 === slot.size || !v.o2)) return v;
        }
        return null;
      };
      var normalize = function (slot) {
        var p = byHandle[slot.h];
        var versions = versionsOf(p);
        if (versions.indexOf(slot.version) === -1) slot.version = versions[0];
        var sizes = sizesOf(p, slot.version);
        if (sizes.length && sizes.indexOf(slot.size) === -1) slot.size = preferSize(sizes);
      };

      var renderSlots = function (animate) {
        if (!products.length) {
          slotsEl.innerHTML = '<li class="builder__empty">Zaimportuj produkty z pliku products.csv, a tutaj pojawi się cała ekipa do wyboru.</li>';
          addBtn.disabled = true;
          return;
        }
        var out = '';
        state.slots.forEach(function (slot, i) {
          var p = byHandle[slot.h];
          var v = variantOf(slot);
          var avatar = '<span class="avatar avatar--face tone-' + esc(p.tone) + '">' + (p.face || esc(p.name.charAt(0))) + '</span>';
          var vOpts = versionsOf(p).map(function (o) { return '<option' + (o === slot.version ? ' selected' : '') + '>' + esc(o) + '</option>'; }).join('');
          var sizes = sizesOf(p, slot.version);
          var sOpts = sizes.map(function (o) { return '<option' + (o === slot.size ? ' selected' : '') + '>' + esc(o) + '</option>'; }).join('');
          var avail = v && v.available;
          out += '<li class="slot tone-' + esc(p.tone) + (avail ? '' : ' is-unavailable') + '" data-slot="' + i + '" style="--i:' + (animate ? i : 0) + '">' +
            '<button type="button" class="slot__char" data-slot-swap aria-label="Zmień postać, teraz ' + esc(p.name) + '">' + avatar + '<span class="slot__swap">' + ICON_SWAP + '</span></button>' +
            '<div class="slot__info"><span class="slot__name">' + esc(p.name) + '</span><div class="slot__selects">' +
              '<label class="vh" for="bv-' + i + '">Wersja</label><select class="slot__select" id="bv-' + i + '" data-k="version">' + vOpts + '</select>' +
              (sizes.length ? '<label class="vh" for="bs-' + i + '">Rozmiar</label><select class="slot__select" id="bs-' + i + '" data-k="size">' + sOpts + '</select>' : '') +
            '</div></div>' +
            '<span class="slot__price">' + (v ? (avail ? formatMoney(v.price) : 'brak') : '') + '</span>' +
          '</li>';
        });
        slotsEl.innerHTML = out;
        updateSum();
      };

      var updateSum = function () {
        var was = 0, ok = true;
        state.slots.forEach(function (s) { var v = variantOf(s); if (!v || !v.available) ok = false; else was += v.price; });
        var now = Math.round(was * (100 - state.pct) / 100);
        $('[data-b-was]', wrap).textContent = formatMoney(was);
        $('[data-b-now]', wrap).textContent = formatMoney(now);
        var save = $('[data-b-save]', wrap);
        save.textContent = formatMoney(was - now);
        restart(save.parentNode, 'is-bump');
        addBtn.disabled = !ok;
        var n = state.slots.length;
        label.textContent = ok ? 'Dodaj ' + n + ' ' + plural(n, 'piżamkę', 'piżamki', 'piżamek') + ' do koszyka' : 'Któryś rozmiar jest chwilowo niedostępny';
      };

      var setTier = function (card, animate) {
        cards.forEach(function (c) {
          var on = c === card;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-checked', on ? 'true' : 'false');
          c.setAttribute('tabindex', on ? '0' : '-1');
        });
        state.qty = parseInt(card.getAttribute('data-tier'), 10) || 2;
        state.pct = parseInt(card.getAttribute('data-pct'), 10) || 0;
        var defs = (card.getAttribute('data-default') || '').split(',').map(function (s) { return s.trim(); }).filter(function (h) { return byHandle[h]; });
        var handles = products.map(function (p) { return p.handle; });
        var baseVersion = state.slots[0] ? state.slots[0].version : 'Dziecięca';
        var baseSize = state.slots[0] ? state.slots[0].size : '150 cm';
        var slots = [];
        for (var i = 0; i < state.qty && products.length; i++) {
          var h = defs[i] || handles[i % handles.length];
          var slot = { h: h, version: baseVersion, size: baseSize };
          normalize(slot);
          slots.push(slot);
        }
        state.slots = slots;
        renderSlots(animate);
      };

      cards.forEach(function (card, idx) {
        card.addEventListener('click', function () { setTier(card, true); });
        card.addEventListener('keydown', function (e) {
          var k = e.key;
          if (k === ' ' || k === 'Enter') { e.preventDefault(); setTier(card, true); return; }
          var dir = (k === 'ArrowDown' || k === 'ArrowRight') ? 1 : (k === 'ArrowUp' || k === 'ArrowLeft') ? -1 : 0;
          if (!dir) return;
          e.preventDefault();
          var next = cards[(idx + dir + cards.length) % cards.length];
          setTier(next, true);
          next.focus();
        });
      });

      slotsEl.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-slot-swap]');
        if (!btn) return;
        var li = btn.closest('[data-slot]');
        var i = parseInt(li.getAttribute('data-slot'), 10);
        var handles = products.map(function (p) { return p.handle; });
        var slot = state.slots[i];
        slot.h = handles[(handles.indexOf(slot.h) + 1) % handles.length];
        normalize(slot);
        renderSlots(false);
        var fresh = $('[data-slot="' + i + '"]', slotsEl);
        if (fresh) { restart(fresh, 'is-swap'); var b = $('[data-slot-swap]', fresh); if (b) b.focus({ preventScroll: true }); }
      });
      slotsEl.addEventListener('change', function (e) {
        var sel = e.target.closest('select[data-k]');
        if (!sel) return;
        var i = parseInt(sel.closest('[data-slot]').getAttribute('data-slot'), 10);
        var slot = state.slots[i];
        slot[sel.getAttribute('data-k')] = sel.value;
        normalize(slot);
        var id = sel.id;
        renderSlots(false);
        var again = doc.getElementById(id);
        if (again) again.focus({ preventScroll: true });
      });

      addBtn.addEventListener('click', function () {
        var items = [];
        state.slots.forEach(function (s) {
          var v = variantOf(s);
          if (!v) return;
          var found = items.filter(function (it) { return it.id === v.id; })[0];
          if (found) found.quantity++; else items.push({ id: v.id, quantity: 1 });
        });
        if (!items.length) return;
        addBtn.classList.add('is-loading');
        addBtn.disabled = true;
        Cart.add(items).then(function () {
          confettiFrom(addBtn, 40);
          Drawer.open('cart');
        }).catch(function (err) {
          toast(err.message);
        }).then(function () {
          addBtn.classList.remove('is-loading');
          addBtn.disabled = false;
        });
      });

      var active = cards.filter(function (c) { return c.classList.contains('is-active'); })[0] || cards[0];
      if (active) setTier(active, false);
    });
  }

  /* ---------- Strona produktu ---------- */
  var DAYS_IN = ['w niedzielę', 'w poniedziałek', 'we wtorek', 'w środę', 'w czwartek', 'w piątek', 'w sobotę'];
  function dispatchText() {
    var d = new Date(), added = 0;
    while (added < 2) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) added++;
    }
    var dd = String(d.getDate()).padStart(2, '0') + '.' + String(d.getMonth() + 1).padStart(2, '0');
    return 'Zamów teraz, a paczka wyjdzie najpóźniej ' + DAYS_IN[d.getDay()] + ' (' + dd + ').';
  }

  function initProduct(root) {
    $$('[data-product]', root).forEach(function (wrap) {
      if (wrap._pdp) return;
      var gallery = initGallery(wrap);
      var data = parseJSON($('[data-product-json]', wrap));
      var squad = parseJSON($('[data-squad-json]', wrap)) || [];
      var form = $('form[data-product-form]', wrap);
      if (!data || !form) return;
      wrap._pdp = true;
      var variants = data.variants || [];
      var idInput = $('[data-variant-id]', form);
      var addBtn = $('[data-add-btn]', form);
      var addLabel = $('[data-add-label]', form);
      var errorEl = $('[data-form-error]', form);
      var fieldsets = $$('[data-option]', form);
      var qbOpts = $$('[data-qb-opt]', form);
      var extrasEl = $('[data-qb-extras]', form);
      var current = variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || variants[0];
      var tier = { q: 1, pct: 0 };
      var extras = [];
      var byHandle = {};
      squad.forEach(function (p) { byHandle[p.handle] = p; });
      var others = squad.map(function (p) { return p.handle; }).filter(function (h) { return h !== data.handle; });
      if (!others.length && byHandle[data.handle]) others = [data.handle];


      var dispatch = $('[data-dispatch-text]', wrap);
      if (dispatch) dispatch.textContent = dispatchText();

      var selected = function () {
        return fieldsets.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
      };
      var findVariant = function (opts) {
        return variants.filter(function (v) {
          return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; });
        })[0];
      };

      var syncAvailability = function () {
        var opts = selected();
        fieldsets.forEach(function (fs, idx) {
          var choices = [];
          $$('[data-opt-input]', fs).forEach(function (input) {
            var chip = input.closest('[data-chip]') || input.closest('.vcard');
            var matches = variants.filter(function (v) {
              for (var k = 0; k < idx; k++) if (String(v.options[k]) !== String(opts[k])) return false;
              return String(v.options[idx]) === input.value;
            });
            var exists = matches.length > 0;
            if (chip) { chip.hidden = !exists; chip.classList.toggle('is-soldout', exists && !matches.some(function (v) { return v.available; })); }
            input.disabled = !exists;
            if (exists) choices.push({ input: input, available: matches.some(function (v) { return v.available; }) });
          });
          var checked = $('input:checked', fs);
          if (!checked || !choices.some(function (c) { return c.input === checked; })) {
            var available = choices.filter(function (c) { return c.available; });
            var pool = available.length ? available : choices;
            var preferred = preferSize(pool.map(function (c) { return c.input.value; }));
            var pick = pool.filter(function (c) { return c.input.value === preferred; })[0] || pool[0];
            $$('[data-opt-input]', fs).forEach(function (i) { i.checked = !!pick && i === pick.input; });
          }
          checked = $('input:checked', fs);
          opts[idx] = checked ? checked.value : null;
        });
      };


      /* Pakiety w formularzu */
      var versionsOf = function (p) {
        var out = [];
        p.variants.forEach(function (v) { if (out.indexOf(v.o1) === -1) out.push(v.o1); });
        return out;
      };
      var sizesOf = function (p, version) {
        var out = [];
        p.variants.forEach(function (v) { if (v.o1 === version && v.o2 && out.indexOf(v.o2) === -1) out.push(v.o2); });
        return out;
      };
      var slotVariant = function (slot) {
        var p = byHandle[slot.h];
        if (!p) return null;
        return p.variants.filter(function (v) { return v.o1 === slot.version && (!v.o2 || v.o2 === slot.size); })[0] || null;
      };
      var normalize = function (slot) {
        var p = byHandle[slot.h];
        if (!p) return;
        var vs = versionsOf(p);
        if (vs.indexOf(slot.version) === -1) slot.version = vs[0];
        var ss = sizesOf(p, slot.version);
        if (ss.length && ss.indexOf(slot.size) === -1) slot.size = preferSize(ss);
      };
      var buildExtras = function (n) {
        var next = [];
        for (var i = 0; i < n - 1 && others.length; i++) {
          var keep = extras[i];
          var slot = keep || { h: others[i % others.length], version: current.options[0], size: current.options[1], touched: false };
          normalize(slot);
          next.push(slot);
        }
        extras = next;
      };
      var renderExtras = function () {
        if (!extrasEl) return;
        if (tier.q < 2 || !extras.length) { extrasEl.innerHTML = ''; return; }
        var me = byHandle[data.handle];
        var out = '<li class="qbx qbx--main">' +
          (me ? '<span class="avatar avatar--face tone-' + esc(me.tone) + '">' + me.face + '</span>' : '') +
          '<span class="qbx__body"><span class="qbx__label">Piżamka 1</span><span class="qbx__fixed">' + esc((me ? me.name + ', ' : '') + current.title.replace(/ \/ /g, ', ')) + '</span></span></li>';
        extras.forEach(function (slot, i) {
          var p = byHandle[slot.h];
          if (!p) return;
          var hOpts = squad.map(function (sp) { return '<option value="' + esc(sp.handle) + '"' + (sp.handle === slot.h ? ' selected' : '') + '>' + esc(sp.name) + '</option>'; }).join('');
          var vOpts = versionsOf(p).map(function (o) { return '<option' + (o === slot.version ? ' selected' : '') + '>' + esc(o) + '</option>'; }).join('');
          var sizes = sizesOf(p, slot.version);
          var sOpts = sizes.map(function (o) { return '<option' + (o === slot.size ? ' selected' : '') + '>' + esc(o) + '</option>'; }).join('');
          var v = slotVariant(slot);
          var n = i + 2;
          out += '<li class="qbx tone-' + esc(p.tone) + (v && v.available ? '' : ' is-unavailable') + '" data-x="' + i + '" style="--i:' + i + '">' +
            '<span class="avatar avatar--face tone-' + esc(p.tone) + '">' + p.face + '</span>' +
            '<span class="qbx__body"><span class="qbx__label">Piżamka ' + n + (v && !v.available ? ', brak rozmiaru' : '') + '</span>' +
            '<span class="qbx__selects">' +
              '<label class="vh" for="qx-' + n + '-h">Postać, piżamka ' + n + '</label><select class="slot__select" id="qx-' + n + '-h" data-k="h">' + hOpts + '</select>' +
              '<label class="vh" for="qx-' + n + '-v">Wersja, piżamka ' + n + '</label><select class="slot__select" id="qx-' + n + '-v" data-k="version">' + vOpts + '</select>' +
              (sizes.length ? '<label class="vh" for="qx-' + n + '-s">Rozmiar, piżamka ' + n + '</label><select class="slot__select" id="qx-' + n + '-s" data-k="size">' + sOpts + '</select>' : '') +
            '</span></span></li>';
        });
        extrasEl.innerHTML = out;
      };

      var totals = function () {
        var unit = current.price;
        var actualWas = unit, ok = current.available;
        extras.slice(0, Math.max(0, tier.q - 1)).forEach(function (s) {
          var v = slotVariant(s);
          if (!v || !v.available) ok = false; else actualWas += v.price;
        });
        qbOpts.forEach(function (opt) {
          var q = parseInt(opt.getAttribute('data-qb-opt'), 10);
          var pct = parseInt($('input', opt).getAttribute('data-pct'), 10) || 0;
          var was = q === tier.q ? actualWas : unit * q;
          var tot = Math.round(was * (100 - pct) / 100);
          var t = $('[data-qb-total]', opt), w = $('[data-qb-was]', opt), e = $('[data-qb-each]', opt);
          if (t) t.textContent = formatMoney(tot);
          if (w) w.textContent = formatMoney(was);
          if (e) e.textContent = formatMoney(Math.round(tot / q));
        });
        var activeTotal = Math.round(actualWas * (100 - tier.pct) / 100);
        if (!current.available) addLabel.textContent = 'Chwilowo brak';
        else if (!ok) addLabel.textContent = 'Wybierz dostępny rozmiar';
        else if (tier.q === 1) addLabel.textContent = 'Dodaj do koszyka · ' + formatMoney(activeTotal);
        else addLabel.textContent = 'Dodaj ' + tier.q + ' ' + plural(tier.q, 'piżamkę', 'piżamki', 'piżamek') + ' · ' + formatMoney(activeTotal);
        addBtn.disabled = !current.available || !ok;
        var stickyScope = wrap._stickyBar || wrap;
        var sp = $('[data-sticky-price]', stickyScope), sw = $('[data-sticky-was]', stickyScope);
        if (sp) sp.textContent = formatMoney(activeTotal);
        if (sw) {
          var swv = tier.q > 1 ? actualWas : (current.compare_at_price > current.price ? current.compare_at_price : 0);
          sw.textContent = swv ? formatMoney(swv) : '';
        }
        var sv = $('[data-sticky-variant]', stickyScope);
        var stickyLabel = $('[data-sticky-label]', stickyScope);
        if (stickyLabel) stickyLabel.textContent = addBtn.disabled ? 'Wybierz rozmiar' : 'Do koszyka · ' + formatMoney(activeTotal);
        if (sv) sv.textContent = tier.q > 1 ? 'Pakiet: ' + tier.q + ' ' + plural(tier.q, 'piżamka', 'piżamki', 'piżamek') + ', -' + tier.pct + '%' : current.title.replace(/ \/ /g, ', ');
      };

      var setTier = function (q, pct) {
        tier.q = q;
        tier.pct = pct;
        qbOpts.forEach(function (o) { o.classList.toggle('is-active', parseInt(o.getAttribute('data-qb-opt'), 10) === q); });
        buildExtras(q);
        renderExtras();
        totals();
        var active = qbOpts.filter(function (o) { return o.classList.contains('is-active'); })[0];
        if (active) restart($('.qb__price', active), 'is-bump');
      };
      qbOpts.forEach(function (opt) {
        var input = $('input', opt);
        input.addEventListener('change', function () {
          if (input.checked) setTier(parseInt(input.value, 10), parseInt(input.getAttribute('data-pct'), 10) || 0);
          if (input.checked && tier.q > 1 && motionOK()) confettiFrom($('.qb__price', opt), 12);
        });
      });
      if (extrasEl) {
        extrasEl.addEventListener('change', function (e) {
          var sel = e.target.closest('select[data-k]');
          if (!sel) return;
          var i = parseInt(sel.closest('[data-x]').getAttribute('data-x'), 10);
          var slot = extras[i];
          slot[sel.getAttribute('data-k')] = sel.value;
          slot.touched = true;
          normalize(slot);
          var id = sel.id;
          renderExtras();
          totals();
          var again = doc.getElementById(id);
          if (again) again.focus({ preventScroll: true });
        });
      }

      var updateStock = function (v) {
        var el = $('[data-stock]', wrap);
        if (!el) return;
        var txt = $('[data-stock-text]', el);
        el.classList.remove('stock--low', 'stock--out');
        if (!v.available) { el.classList.add('stock--out'); txt.textContent = 'Ten rozmiar chwilowo się skończył'; return; }
        if (v.inv !== null && v.inv > 0 && v.inv <= data.low) {
          el.classList.add('stock--low');
          txt.textContent = 'Ostatnie ' + v.inv + ' szt. w tym rozmiarze';
          return;
        }
        txt.textContent = 'Dostępna, wysyłka w 48 h';
      };

      var updatePrice = function (v, changed) {
        var box = $('[data-price-wrap]', wrap);
        if (!box) return;
        var promo = v.compare_at_price && v.compare_at_price > v.price;
        $('[data-price]', box).textContent = formatMoney(v.price);
        var cmp = $('[data-compare]', box), off = $('[data-off]', box), save = $('[data-save]', box);
        var om = $('[data-omnibus]', box), omp = $('[data-omnibus-price]', box);
        cmp.hidden = off.hidden = save.hidden = !promo;
        if (om) om.hidden = !promo;
        if (promo) {
          var pc = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
          cmp.textContent = formatMoney(v.compare_at_price);
          off.textContent = '-' + pc + '%';
          save.textContent = 'Oszczędzasz ' + formatMoney(v.compare_at_price - v.price);
          if (omp) omp.textContent = formatMoney(v.compare_at_price);
          var go = $('[data-gallery-off]', wrap);
          if (go) go.textContent = '-' + pc + '%';
        }
        if (changed) restart($('.price', box), 'is-bump');
      };

      var update = function () {
        var v = findVariant(selected());
        if (!v) { idInput.value = ''; addBtn.disabled = true; addLabel.textContent = 'Wybierz dostępny wariant'; return; }
        var changed = v.id !== current.id;
        current = v;
        idInput.value = v.id;
        fieldsets.forEach(function (fs, i) { var b = $('[data-option-value]', fs); if (b) b.textContent = v.options[i]; });
        updatePrice(v, changed);
        updateStock(v);
        extras.forEach(function (s) { if (!s.touched) { s.version = v.options[0]; s.size = v.options[1]; normalize(s); } });
        renderExtras();
        totals();
        if (!P.designMode && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        if (v.media && gallery) gallery.goToMedia(v.media);
      };

      fieldsets.forEach(function (fs, idx) {
        fs.addEventListener('change', function () { syncAvailability(idx); update(); });
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!current.available || !idInput.value || addBtn.classList.contains('is-loading')) return;
        errorEl.hidden = true;
        var items = [{ id: current.id, quantity: 1 }];
        var bad = false;
        extras.slice(0, Math.max(0, tier.q - 1)).forEach(function (s) {
          var v = slotVariant(s);
          if (!v || !v.available) { bad = true; return; }
          var found = items.filter(function (it) { return it.id === v.id; })[0];
          if (found) found.quantity++; else items.push({ id: v.id, quantity: 1 });
        });
        if (bad) { errorEl.textContent = 'Któraś piżamka z pakietu nie ma wybranego rozmiaru. Zmień go i spróbuj jeszcze raz.'; errorEl.hidden = false; return; }
        addBtn.classList.add('is-loading');
        addBtn.disabled = true;
        Cart.add(items).then(function () {
          confettiFrom(addBtn, 40);
          Drawer.open('cart');
        }).catch(function (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
        }).then(function () {
          addBtn.classList.remove('is-loading');
          totals();
        });
      });

      gallery = initGallery(wrap);
      initSticky(wrap, form, addBtn);
      syncAvailability(-1);
      updateStock(current);
      totals();
    });
  }

  function initGallery(wrap) {
    if (wrap._galleryController) return wrap._galleryController;
    var track = $('[data-gallery-track]', wrap);
    if (!track) return null;
    var slides = $$('.gallery__slide', track);
    var thumbs = $$('[data-thumb]', wrap), dots = $$('[data-gallery-dot]', wrap);
    var positions = function () { return slides.map(function (s) { return s.offsetLeft - slides[0].offsetLeft; }); };
    var index = 0, queued = false;
    var update = function () {
      queued = false;
      var pos = positions(), best = Infinity;
      pos.forEach(function (x, i) { var distance = Math.abs(track.scrollLeft - x); if (distance < best) { best = distance; index = i; } });
      thumbs.concat(dots).forEach(function (control) {
        var i = Number(control.getAttribute('data-thumb') || control.getAttribute('data-gallery-dot') || 0);
        control.classList.toggle('is-active', i === index);
        if (i === index) control.setAttribute('aria-current', 'true'); else control.removeAttribute('aria-current');
      });
      var nextImage = slides[index + 1] ? $('img', slides[index + 1]) : null;
      if (nextImage) nextImage.loading = 'eager';
    };
    var schedule = function () { if (!queued) { queued = true; requestAnimationFrame(update); } };
    var go = function (i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: positions()[i], behavior: motionOK() ? 'smooth' : 'auto' }); schedule(); };
    thumbs.concat(dots).forEach(function (b) { b.addEventListener('click', function () { go(Number(b.getAttribute('data-thumb') || b.getAttribute('data-gallery-dot') || 0)); }); });
    var prev = $('[data-gallery-prev]', wrap), next = $('[data-gallery-next]', wrap);
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    track.addEventListener('scroll', schedule, { passive: true });
    track.addEventListener('scrollend', update);
    track.addEventListener('touchend', schedule, { passive: true });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); go(index + (e.key === 'ArrowRight' ? 1 : -1)); } });
    if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(track);
    update();
    wrap._galleryController = { goToMedia: function (id) { var i = slides.findIndex(function (s) { return s.dataset.mediaId === String(id); }); if (i >= 0) go(i); } };
    return wrap._galleryController;
  }

  function initSticky(wrap, form, addBtn) {
    if (wrap._stickyBar) return;
    var bar = $('[data-sticky-atc]', wrap);
    if (!bar) return;
    wrap._stickyBar = bar;
    doc.body.appendChild(bar);
    var btn = $('[data-sticky-add]', bar), queued = false;
    var update = function () {
      queued = false;
      if (!wrap.isConnected) { bar.remove(); window.removeEventListener('scroll', schedule); return; }
      var show = addBtn.getBoundingClientRect().bottom <= 78 && !html.classList.contains('lock');
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      btn.tabIndex = show ? 0 : -1;
      btn.disabled = addBtn.disabled;
      btn.classList.toggle('is-loading', addBtn.classList.contains('is-loading'));
      doc.body.classList.toggle('has-sticky', show);
    };
    var schedule = function () { if (!queued) { queued = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule, { passive: true });
    if ('IntersectionObserver' in window) new IntersectionObserver(schedule).observe(addBtn);
    new MutationObserver(schedule).observe(addBtn, { attributes: true, attributeFilter: ['disabled', 'class'] });
    btn.addEventListener('click', function () { if (addBtn.disabled) return; if (form.requestSubmit) form.requestSubmit(); else addBtn.click(); });
    update();
  }


  /* ---------- Poznaj ekipę: wybór postaci ---------- */
  function initSpot(root) {
    $$('[data-spot]', root).forEach(function (wrap) {
      if (wrap._spot) return;
      wrap._spot = true;
      var tabs = $$('[data-spot-tab]', wrap);
      var panels = $$('[data-spot-panel]', wrap);
      if (!tabs.length) return;
      var idx = 0;
      var show = function (i, focus) {
        i = (i + tabs.length) % tabs.length;
        if (i === idx && !focus) return;
        idx = i;
        tabs.forEach(function (t, j) {
          t.setAttribute('aria-selected', j === i ? 'true' : 'false');
          t.tabIndex = j === i ? 0 : -1;
        });
        panels.forEach(function (p, j) {
          p.hidden = j !== i;
          if (j === i && motionOK()) restart(p, 'is-enter');
        });
        initTilt(panels[i]);
        if (focus) tabs[i].focus();
      };
      tabs.forEach(function (t, j) {
        t.addEventListener('click', function () { show(j); if (motionOK()) restart(t, 'is-boing'); });
        t.addEventListener('keydown', function (e) {
          var k = e.key, to = null;
          if (k === 'ArrowRight' || k === 'ArrowDown') to = j + 1;
          if (k === 'ArrowLeft' || k === 'ArrowUp') to = j - 1;
          if (k === 'Home') to = 0;
          if (k === 'End') to = tabs.length - 1;
          if (to === null) return;
          e.preventDefault();
          show(to, true);
        });
      });
      var prev = $('[data-spot-prev]', wrap), next = $('[data-spot-next]', wrap);
      if (prev) prev.addEventListener('click', function () { show(idx - 1); });
      if (next) next.addEventListener('click', function () { show(idx + 1); });
      var sx = null, sy = null;
      panels.forEach(function (p) {
        var stage = $('.spot__stage', p);
        if (!stage) return;
        stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (sx === null) return;
          var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) show(idx + (dx < 0 ? 1 : -1));
          sx = null;
        }, { passive: true });
      });
    });
  }

  /* ---------- Szybkie dodawanie (Poznaj ekipę) ---------- */
  function initQuickForms() {
    doc.addEventListener('submit', function (e) {
      var f = e.target.closest && e.target.closest('[data-quick-form]');
      if (!f) return;
      e.preventDefault();
      var sel = $('[name="id"]', f), btn = $('[type="submit"]', f);
      if (!sel || !btn) return;
      btn.classList.add('is-loading');
      btn.disabled = true;
      Cart.add([{ id: parseInt(sel.value, 10), quantity: 1 }]).then(function () {
        confettiFrom(btn, 30);
        Drawer.open('cart');
      }).catch(function (err) {
        toast(err.message);
      }).then(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
    });
  }

  /* ---------- Licznik promocji (stała data z ustawień) ---------- */
  function parseEnd(str) {
    var m = String(str || '').trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
    if (!m) return null;
    return new Date(+m[1], +m[2] - 1, +m[3], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59, m[4] ? 0 : 59);
  }
  var promoTicker = null;
  function initPromoTimers() {
    if (promoTicker) return;
    var tick = function () {
      var now = Date.now();
      $$('[data-promo-timer]').forEach(function (el) {
        if (el._end === undefined) el._end = parseEnd(el.getAttribute('data-end'));
        if (!el._end || el._end - now <= 0) { el.hidden = true; return; }
        var diff = el._end - now;
        var set = function (k, v) {
          var b = $('[data-t="' + k + '"]', el);
          if (!b) return;
          var str = String(v).padStart(2, '0');
          if (b.textContent !== str) { b.textContent = str; if (motionOK()) restart(b, 'is-tick'); }
        };
        set('d', Math.floor(diff / 864e5));
        set('h', Math.floor(diff / 36e5) % 24);
        set('m', Math.floor(diff / 6e4) % 60);
        set('s', Math.floor(diff / 1e3) % 60);
        el.classList.toggle('is-urgent', diff < 864e5);
        el.classList.add('is-ready');
      });
    };
    tick();
    promoTicker = setInterval(tick, 1000);
  }

  /* ---------- Dobór rozmiaru ---------- */
  function recommend(h) {
    var kids = [[115, '110 cm', '105 do 115 cm'], [125, '120 cm', '115 do 125 cm'], [135, '130 cm', '125 do 135 cm'], [145, '140 cm', '135 do 145 cm'], [155, '150 cm', '145 do 155 cm'], [164, '160 cm', '155 do 163 cm']];
    var adults = [[167, 'S', '160 do 167 cm'], [174, 'M', '167 do 174 cm'], [181, 'L', '174 do 181 cm'], [188, 'XL', '181 do 188 cm'], [999, 'XXL', '188 do 196 cm']];
    var i;
    for (i = 0; i < kids.length; i++) {
      if (h < kids[i][0]) {
        var note = 'Dla wzrostu ' + kids[i][2] + '.';
        if (h < 105) note = 'To najmniejszy rozmiar. Będzie luźno, ale rękawy łatwo podwinąć.';
        if (h >= 150) note += ' Wolisz krój dorosły? Weź XS.';
        return { badge: kids[i][1], pick: 'Wersja dziecięca, rozmiar ' + kids[i][1], note: note };
      }
    }
    for (i = 0; i < adults.length; i++) {
      if (h < adults[i][0]) {
        var n2 = 'Dla wzrostu ' + adults[i][2] + '.';
        if (h > 196) n2 = 'Największy rozmiar. Nogawki mogą być trochę krótsze, ale będzie wygodnie.';
        return { badge: adults[i][1], pick: 'Wersja dorosła, rozmiar ' + adults[i][1], note: n2 };
      }
    }
    return { badge: 'XXL', pick: 'Wersja dorosła, rozmiar XXL', note: '' };
  }

  function initSizer(root) {
    $$('[data-sizer]', root).forEach(function (wrap) {
      if (wrap._sizer) return;
      wrap._sizer = true;
      var range = $('[data-sizer-range]', wrap);
      var out = $('[data-sizer-out]', wrap);
      var badge = $('[data-sizer-badge]', wrap);
      var pick = $('[data-sizer-pick]', wrap);
      var note = $('[data-sizer-note]', wrap);
      var fig = $('[data-sizer-fig]', wrap);
      var tag = $('[data-sizer-tag]', wrap);
      var lastBadge = null;
      var apply = function (boing) {
        var h = parseInt(range.value, 10);
        var min = parseInt(range.min, 10), max = parseInt(range.max, 10);
        out.textContent = h;
        if (tag) tag.textContent = h;
        range.style.setProperty('--fill', ((h - min) / (max - min) * 100).toFixed(1) + '%');
        var r = recommend(h);
        badge.textContent = r.badge;
        pick.textContent = r.pick;
        note.textContent = r.note;
        if (lastBadge !== null && lastBadge !== r.badge) restart(badge, 'is-bump');
        lastBadge = r.badge;
        if (fig) {
          fig.style.setProperty('--h', (h / 200).toFixed(3));
          if (boing && motionOK()) restart(fig, 'is-boing');
        }
      };
      var boingTimer;
      range.addEventListener('input', function () {
        apply(false);
        clearTimeout(boingTimer);
        boingTimer = setTimeout(function () { if (fig && motionOK()) restart(fig, 'is-boing'); }, 160);
      });
      // Przymierz postać: zmienia głowę, kolory i ogonek postaci na scenie
      $$('[data-sizer-char]', wrap).forEach(function (chip) {
        chip.addEventListener('click', function () {
          var who = chip.getAttribute('data-sizer-char');
          $$('[data-sizer-char]', wrap).forEach(function (c) { c.classList.toggle('is-active', c === chip); c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
          if (!fig) return;
          fig.style.setProperty('--fig', chip.getAttribute('data-sizer-color'));
          fig.style.setProperty('--fig-2', chip.getAttribute('data-sizer-belly') || '#fff');
          fig.setAttribute('data-char', who);
          $$('[data-sizer-head]', fig).forEach(function (el) { el.classList.toggle('is-on', el.getAttribute('data-sizer-head') === who); });
          if (motionOK()) restart(fig, 'is-boing');
        });
      });
      apply(false);
    });
  }

  /* ---------- Legitymacja członka ekipy ---------- */
  function initMember(root) {
    $$('[data-member]', root).forEach(function (wrap) {
      if (wrap._member) return;
      wrap._member = true;
      var nameIn = $('[data-member-name]', wrap);
      var nameOut = $('[data-member-name-out]', wrap);
      var charOut = $('[data-member-char-out]', wrap);
      var tags = $('[data-member-tags]', wrap);
      var no = $('[data-member-no]', wrap);
      var num;
      try { num = localStorage.getItem('pluszkowo-member'); } catch (e) {}
      if (!num) {
        num = String(1000 + Math.floor(Math.random() * 89000)).padStart(5, '0');
        try { localStorage.setItem('pluszkowo-member', num); } catch (e) {}
      }
      if (no) no.textContent = num;
      if (nameIn && nameOut) {
        nameIn.addEventListener('input', function () {
          nameOut.textContent = nameIn.value.trim() || 'Twoje imię';
          restart(nameOut, 'is-pop');
        });
      }
      $$('[data-member-char]', wrap).forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          var h = radio.value;
          if (charOut) { charOut.textContent = radio.getAttribute('data-name'); restart(charOut, 'is-pop'); }
          $$('[data-ava]', wrap).forEach(function (a) { a.classList.toggle('is-on', a.getAttribute('data-ava') === h); });
          if (tags) tags.value = 'newsletter, ekipa, ulubiona-' + h;
        });
      });
    });
  }

  /* ---------- Rechotek zza rogu ---------- */
  function initPeek() {
    if (!finePointer) return;
    var peek = $('[data-peek]');
    if (!peek) return;
    var hidden = false;
    try { hidden = sessionStorage.getItem('pluszkowo-peek') === 'off'; } catch (e) {}
    if (hidden) { peek.remove(); return; }
    var lines = [];
    try { lines = JSON.parse(peek.getAttribute('data-lines')) || []; } catch (e) {}
    var bubble = $('[data-peek-bubble]', peek);
    var idx = Math.floor(Math.random() * Math.max(1, lines.length));
    var hideTimer, shown = 0;
    var show = function () {
      if (!lines.length) return;
      bubble.textContent = lines[idx++ % lines.length];
      peek.classList.add('is-up', 'is-talking');
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        peek.classList.remove('is-talking');
        setTimeout(function () { peek.classList.remove('is-up'); }, 900);
      }, 6500);
    };
    var first = function () {
      if (shown > 0) return;
      shown++;
      show();
      setTimeout(function () { if (shown < 2) { shown++; show(); } }, 55000);
    };
    setTimeout(first, 9000);
    window.addEventListener('scroll', function onS() {
      var p = window.scrollY / Math.max(1, doc.body.scrollHeight - window.innerHeight);
      if (p > 0.4) { first(); window.removeEventListener('scroll', onS); }
    }, { passive: true });
    $('[data-peek-frog]', peek).addEventListener('click', function () {
      show();
      if (motionOK()) confettiFrom($('[data-peek-frog]', peek), 10);
    });
    $('[data-peek-hide]', peek).addEventListener('click', function () {
      peek.classList.remove('is-up', 'is-talking');
      try { sessionStorage.setItem('pluszkowo-peek', 'off'); } catch (e) {}
      setTimeout(function () { peek.remove(); }, 600);
    });
  }

  /* ---------- Drobiazgi ---------- */
  function initMisc(root) {
    $$('form[data-autosubmit] select', root).forEach(function (s) {
      s.addEventListener('change', function () { s.form.submit(); });
    });
  }

  /* ---------- Start ---------- */
  var magicObserver;
  function initMagic(root) {
    if (!motionOK() || !('IntersectionObserver' in window)) return;
    if (!magicObserver) magicObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { en.target.classList.toggle('magic-visible', en.isIntersecting); });
    }, { rootMargin: '80px' });
    $$('.hero__art, .why__art, .crew__photo, .squad__bg', root).forEach(function (el) {
      if (el.dataset.magicReady) return;
      el.dataset.magicReady = 'true';
      el.classList.add('magic-scene');
      for (var i = 0; i < (finePointer ? 4 : 2); i++) {
        var star = doc.createElement('span');
        star.className = 'magic-particle';
        star.setAttribute('aria-hidden', 'true');
        star.style.left = (7 + ((i * 31) % 86)) + '%';
        star.style.top = (5 + ((i * 19) % 86)) + '%';
        star.style.setProperty('--magic-color', PALETTE[i]);
        star.style.setProperty('--magic-duration', (7 + i * .6) + 's');
        star.style.setProperty('--magic-delay', (-i * 1.3) + 's');
        star.innerHTML = SHAPES[0].replace(/C/, PALETTE[i]);
        el.appendChild(star);
      }
      magicObserver.observe(el);
    });
  }
  doc.addEventListener('visibilitychange', function () { html.classList.toggle('magic-hidden', doc.hidden); });
  reduceMq.addEventListener('change', function () {
    if (!motionOK()) $$('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); });
  });
  function initTypography() {
    var skip = 'script,style,textarea,select,option,code,pre,svg,[contenteditable]';
    function fix(root) {
      if (!root || (root.nodeType === 1 && root.closest(skip))) return;
      var nodes = [];
      if (root.nodeType === 3) nodes.push(root);
      else if (root.nodeType === 1 || root.nodeType === 9) {
        var walker = doc.createTreeWalker(root, NodeFilter.SHOW_TEXT);var node;
        while ((node = walker.nextNode())) nodes.push(node);
      }
      nodes.forEach(function (n) {
        if (!n.parentElement || n.parentElement.closest(skip)) return;
        var text = n.nodeValue;
        var next = text.replace(/(\d(?:[\d.,]*\d)?)[ \t]+(zł|PLN|cm|mm|kg|h|dni|godzin|szt\.|opinii)(?![a-ząćęłńóśźż])/gi, '$1\u00a0$2')
          .replace(/(^|[ \t\u00a0(])([aiouwz])[ \t]+(?=[A-Za-zĄĆĘŁŃÓŚŹŻąćęłńóśźż0-9])/gim, '$1$2\u00a0');
        if (next !== text) n.nodeValue = next;
      });
    }
    var description = $('[data-product-description]');
    if (description && window.matchMedia('(max-width:749px)').matches) description.open = false;
    fix(doc.body);
    var pending = new Set(), queued = false;
    new MutationObserver(function (records) {
      records.forEach(function (r) {
        if (r.type === 'characterData') pending.add(r.target);
        else r.addedNodes.forEach(function (n) { pending.add(n); });
      });
      if (queued) return;queued = true;
      requestAnimationFrame(function () { queued = false;var roots = Array.from(pending);pending.clear();roots.forEach(fix); });
    }).observe(doc.body, { childList:true, characterData:true, subtree:true });
  }

  function safeInit(fn, root) {
    try { fn(root); } catch (e) { html.classList.add('no-anim'); if (window.console) console.warn('Pluszkowo: ' + fn.name, e); }
  }
  function initSection(root) {
    safeInit(initMagic, root);
    safeInit(initReveal, root);
    safeInit(initTilt, root);
    safeInit(initMagnet, root);
    safeInit(initMarquee, root);
    safeInit(initFlip, root);
    safeInit(initCounters, root);
    safeInit(initCountdown, root);
    safeInit(initQuiz, root);
    safeInit(initBundles, root);
    safeInit(initProduct, root);
    safeInit(initSpot, root);
    safeInit(initSizer, root);
    safeInit(initMember, root);
    safeInit(initMisc, root);
  }

  function boot() {
    $$('[data-split]').forEach(function (el) { if (finePointer && motionOK()) splitText(el); });
    safeInit(initDrawers, doc);
    safeInit(initCart, doc);
    safeInit(initHeader, doc);
    safeInit(initNight, doc);
    safeInit(initModals, doc);
    safeInit(initJelly, doc);
    safeInit(initQuickForms, doc);
    safeInit(initPromoTimers, doc);
    safeInit(initSection, doc);
    safeInit(initTypography, doc);
    window.PluszkowoBooted = true;
    html.classList.add('page-ready');
    var decorative = function () { safeInit(initGoogly, doc); safeInit(initParallax, doc); safeInit(initPaws, doc); safeInit(initPeek, doc); };
    if (window.requestIdleCallback) requestIdleCallback(decorative, { timeout: 1200 }); else setTimeout(decorative, 120);

    doc.addEventListener('shopify:section:load', function (e) {
      initSection(e.target);
      $$('[data-split]', e.target).forEach(function (el) { if (motionOK()) splitText(el); });
    });
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();

  P.cart = Cart;
  P.confetti = confetti;
  P.formatMoney = formatMoney;
})();
